import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Image from "./image"
import Hidden from "@material-ui/core/Hidden"

const Hero = () => {
  return (
    <Grid container spacing={3} style={{ marginTop: 40, marginBottom: 20 }}>
      <Grid
        item={true}
        xs={12}
        sm={6}
        container
        direction="column"
        justify="center"
        alignItems="flex-start"
        style={{ paddingLeft: 40, paddingRight: 40 }}
      >
        <Typography variant="h4" color="inherit" style={{ marginBottom: 20 }}>
          Le suivi des patients en Médecine Générale après une chirurgie de
          l’obésité
        </Typography>

        <Typography variant="subtitle1" style={{ marginBottom: 30 }}>
          Ce site propose une aide au suivi des patients ayant bénéficié d’une
          chirurgie bariatrique, à destination des médecins généralistes.
        </Typography>
      </Grid>
      <Hidden xsDown>
        <Grid
          item={true}
          sm={6}
          container
          direction="column"
          justify="center"
          alignItems="flex-start"
          style={{ padding: 10 }}
        >
          <div style={{ width: "100%" }}>
            <Image alt="Bariamed logo" filename="illu.png" />
          </div>
        </Grid>
      </Hidden>
    </Grid>
  )
}
export default Hero
